import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { SimpleOrgMember } from '@euler/model/SimpleOrgMember';
import { Search, UserPlus } from 'lucide-react-native';
import { memo, useMemo, useState } from 'react';
import { Pressable, TextInput, View } from 'react-native';

const kShown = 6;

/** Finds a member of this store to grant; the list is the store's only. */
export const MemberPicker = memo(
  ({
    members,
    onPick,
  }: {
    /** Members that can still be granted. */
    members: SimpleOrgMember[];
    onPick: (member: SimpleOrgMember) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const [query, setQuery] = useState('');
    const matches = useMemo(() => {
      const text = query.trim();
      return members
        .filter(member => !text || member.name.includes(text))
        .slice(0, kShown);
    }, [members, query]);
    return (
      <View style={{ gap: rpx(6) }}>
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            gap: rpx(8),
            height: rpx(36),
            paddingHorizontal: rpx(10),
            borderRadius: rpx(10),
            backgroundColor: aiColors.input,
          }}
        >
          <Search size={14} color={aiColors.mutedForeground} />
          <TextInput
            accessibilityLabel="搜索成员"
            value={query}
            onChangeText={setQuery}
            placeholder="搜索本店成员"
            placeholderTextColor={aiColors.mutedForeground}
            style={{ flex: 1, color: aiColors.foreground, fontSize: rpx(13) }}
          />
        </View>
        {matches.map(member => (
          <Pressable
            key={member.id}
            accessibilityRole="button"
            accessibilityLabel={`添加 ${member.name}`}
            onPress={() => onPick(member)}
            style={({ pressed }) => ({
              flexDirection: 'row',
              alignItems: 'center',
              gap: rpx(8),
              paddingVertical: rpx(6),
              paddingHorizontal: rpx(4),
              borderRadius: rpx(8),
              opacity: pressed ? 0.7 : 1,
            })}
          >
            <UserPlus size={14} color={aiColors.primary} />
            <Typography.Text size={rpx(13)} color={aiColors.foreground}>
              {member.name}
            </Typography.Text>
            {member.jobTitle ? (
              <Typography.Text size={rpx(11)} color={aiColors.mutedForeground}>
                {member.jobTitle}
              </Typography.Text>
            ) : null}
          </Pressable>
        ))}
        {!matches.length ? (
          <Typography.Text size={rpx(12)} color={aiColors.mutedForeground}>
            没有可添加的成员
          </Typography.Text>
        ) : null}
      </View>
    );
  },
);
